/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'./api/VisIndicatorsAPI',
	'underscore'
], (APIFactory, VisIndicatorsAPI, _) => {

	class VisIndicators {

		constructor() {
			this.api = APIFactory.createAPI(this, [VisIndicatorsAPI]);
			this.providers = [];
		}

		registerProvider(provider) {
			this.providers.push(provider);
		}

		getIndicatorList() {
			let indicators = [];

			_.each(this.providers, (provider) => {
				if (provider.getIndicatorList) {
					indicators.push(...provider.getIndicatorList());
				}
			});

			return indicators;
		}

		getAPI(){
			return this.api;
		}
	}

	return VisIndicators;
});
